import React, {Component} from "react";

class SubscriptionStatus extends Component {
    constructor() {
        super();

        this.state = {
            status: {
                text: 'Loading',
                className: 'label-default'
            },
        };
    }

    componentDidMount() {
        this.updateState(this.props.subscription);
    }

    componentWillReceiveProps(nextProps) {
        this.updateState(nextProps.subscription);
    }

    updateState = (update) => {
        if (update.status) {
            this.setState({
                status: update.status,
            });
        }
    };

    render() {
        return (
            <div className="row">
                <div className="col-sm-12 m-b-sm">
                    <p>
                        Your subscription status is: <span className={`label ${this.state.status.className}`}
                                                           id="subscription-status">{this.state.status.text}</span>
                    </p>
                </div>
            </div>
        );
    }
}

SubscriptionStatus.propTypes = {
    subscription: React.PropTypes.object.isRequired,
};

export default SubscriptionStatus;



// WEBPACK FOOTER //
// ./src/modules/views/product/SubscriptionStatus.js